import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_STORE_OPENING_TIMES_BY_ID } from "../../../../../queries/v3/queries/get-store-opening-times-by-id.js";
import { fromStoreOpeningTimesByIdQueryToOpeningTimes } from "../../../adapters/v3/hooks/api/adapters/fromStoreOpeningTimesByIdQueryToOpeningTimes.js";
const useStoreOpeningTimesById = () => {
  const [query, queryState] = useLazyQuery(GET_STORE_OPENING_TIMES_BY_ID);
  const data = React.useMemo(
    () => fromStoreOpeningTimesByIdQueryToOpeningTimes(queryState.data?.store),
    [queryState.data]
  );
  return React.useMemo(() => [query, { ...queryState, data }], [query, queryState, data]);
};
export {
  useStoreOpeningTimesById as default,
  useStoreOpeningTimesById
};
//# sourceMappingURL=use-store-opening-times-by-id.js.map
